/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { consolidationAiRetrieveStatusByResponseId } from '../fn/esg-consolidation/consolidation-ai-retrieve-status-by-response-id';
import { ConsolidationAiRetrieveStatusByResponseId$Params } from '../fn/esg-consolidation/consolidation-ai-retrieve-status-by-response-id';
import { consolidationDatapointByProfileByYearByCodeByDatapointIdList } from '../fn/esg-consolidation/consolidation-datapoint-by-profile-by-year-by-code-by-datapoint-id-list';
import { ConsolidationDatapointByProfileByYearByCodeByDatapointIdList$Params } from '../fn/esg-consolidation/consolidation-datapoint-by-profile-by-year-by-code-by-datapoint-id-list';
import { consolidationProfileByYearByCodeByDatapointIdNarrativeAi } from '../fn/esg-consolidation/consolidation-profile-by-year-by-code-by-datapoint-id-narrative-ai';
import { ConsolidationProfileByYearByCodeByDatapointIdNarrativeAi$Params } from '../fn/esg-consolidation/consolidation-profile-by-year-by-code-by-datapoint-id-narrative-ai';
import { consolidationTicketByProfileByYearByCodeList } from '../fn/esg-consolidation/consolidation-ticket-by-profile-by-year-by-code-list';
import { ConsolidationTicketByProfileByYearByCodeList$Params } from '../fn/esg-consolidation/consolidation-ticket-by-profile-by-year-by-code-list';
import { EsgConsolidationCreateRequestResponse } from '../models/esg-consolidation-create-request-response';
import { EsgConsolidationDatapointWithProfileId } from '../models/esg-consolidation-datapoint-with-profile-id';
import { EsgConsolidationNarrativeAiResponse } from '../models/esg-consolidation-narrative-ai-response';
import { EsgConsolidationTicketsWithProfileId } from '../models/esg-consolidation-tickets-with-profile-id';

@Injectable({ providedIn: 'root' })
export class EsgConsolidationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `consolidationDatapointByProfileByYearByCodeByDatapointIdList()` */
  static readonly ConsolidationDatapointByProfileByYearByCodeByDatapointIdListPath = '/esg/profile/consolidation/{profileId}/{year}/{code}/datapoint/{dataPointId}';

  /**
   * Get list of datapoints for all profiles which belongs to consolidation group of specified profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consolidationDatapointByProfileByYearByCodeByDatapointIdList()` instead.
   *
   * This method doesn't expect any request body.
   */
  consolidationDatapointByProfileByYearByCodeByDatapointIdList$Response(params: ConsolidationDatapointByProfileByYearByCodeByDatapointIdList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EsgConsolidationDatapointWithProfileId>>> {
    return consolidationDatapointByProfileByYearByCodeByDatapointIdList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of datapoints for all profiles which belongs to consolidation group of specified profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consolidationDatapointByProfileByYearByCodeByDatapointIdList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consolidationDatapointByProfileByYearByCodeByDatapointIdList(params: ConsolidationDatapointByProfileByYearByCodeByDatapointIdList$Params, context?: HttpContext): Observable<Array<EsgConsolidationDatapointWithProfileId>> {
    return this.consolidationDatapointByProfileByYearByCodeByDatapointIdList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EsgConsolidationDatapointWithProfileId>>): Array<EsgConsolidationDatapointWithProfileId> => r.body)
    );
  }

  /** Path part for operation `consolidationTicketByProfileByYearByCodeList()` */
  static readonly ConsolidationTicketByProfileByYearByCodeListPath = '/esg/profile/consolidation/{profileId}/{year}/{code}/ticket';

  /**
   * Get list of tickets for all profiles which belongs to consolidation group of specified profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consolidationTicketByProfileByYearByCodeList()` instead.
   *
   * This method doesn't expect any request body.
   */
  consolidationTicketByProfileByYearByCodeList$Response(params: ConsolidationTicketByProfileByYearByCodeList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EsgConsolidationTicketsWithProfileId>>> {
    return consolidationTicketByProfileByYearByCodeList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of tickets for all profiles which belongs to consolidation group of specified profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consolidationTicketByProfileByYearByCodeList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consolidationTicketByProfileByYearByCodeList(params: ConsolidationTicketByProfileByYearByCodeList$Params, context?: HttpContext): Observable<Array<EsgConsolidationTicketsWithProfileId>> {
    return this.consolidationTicketByProfileByYearByCodeList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EsgConsolidationTicketsWithProfileId>>): Array<EsgConsolidationTicketsWithProfileId> => r.body)
    );
  }

  /** Path part for operation `consolidationProfileByYearByCodeByDatapointIdNarrativeAi()` */
  static readonly ConsolidationProfileByYearByCodeByDatapointIdNarrativeAiPath = '/esg/profile/consolidation/{profileId}/{year}/{code}/datapoint/{dataPointId}/narrative-ai';

  /**
   * Consolidate narrative datapoints for all profiles which belongs to consolidation group of specified profile with AI.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consolidationProfileByYearByCodeByDatapointIdNarrativeAi()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consolidationProfileByYearByCodeByDatapointIdNarrativeAi$Response(params: ConsolidationProfileByYearByCodeByDatapointIdNarrativeAi$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgConsolidationCreateRequestResponse>> {
    return consolidationProfileByYearByCodeByDatapointIdNarrativeAi(this.http, this.rootUrl, params, context);
  }

  /**
   * Consolidate narrative datapoints for all profiles which belongs to consolidation group of specified profile with AI.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consolidationProfileByYearByCodeByDatapointIdNarrativeAi$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consolidationProfileByYearByCodeByDatapointIdNarrativeAi(params: ConsolidationProfileByYearByCodeByDatapointIdNarrativeAi$Params, context?: HttpContext): Observable<EsgConsolidationCreateRequestResponse> {
    return this.consolidationProfileByYearByCodeByDatapointIdNarrativeAi$Response(params, context).pipe(
      map((r: StrictHttpResponse<EsgConsolidationCreateRequestResponse>): EsgConsolidationCreateRequestResponse => r.body)
    );
  }

  /** Path part for operation `consolidationAiRetrieveStatusByResponseId()` */
  static readonly ConsolidationAiRetrieveStatusByResponseIdPath = '/esg/profile/consolidation/{profileId}/{year}/{code}/datapoint/{dataPointId}/narrative-ai/{responseId}';

  /**
   * Get ai response status by response ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consolidationAiRetrieveStatusByResponseId()` instead.
   *
   * This method doesn't expect any request body.
   */
  consolidationAiRetrieveStatusByResponseId$Response(params: ConsolidationAiRetrieveStatusByResponseId$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgConsolidationNarrativeAiResponse>> {
    return consolidationAiRetrieveStatusByResponseId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ai response status by response ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consolidationAiRetrieveStatusByResponseId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consolidationAiRetrieveStatusByResponseId(params: ConsolidationAiRetrieveStatusByResponseId$Params, context?: HttpContext): Observable<EsgConsolidationNarrativeAiResponse> {
    return this.consolidationAiRetrieveStatusByResponseId$Response(params, context).pipe(
      map((r: StrictHttpResponse<EsgConsolidationNarrativeAiResponse>): EsgConsolidationNarrativeAiResponse => r.body)
    );
  }

}
